export class EnumApiContent {
    constructor() {
        /**
         * @des 直播活动
         */
        this.content_live_activity = {
            // url: '/api/gateway/pcsd-bp-customer-bff-content/v1/bff/content/activity/info/listForPage',
            url: '/api/gateway/pcsd-bp-customer-bff-content/v1/WorkbenchCockpit/latestActivityInfo',
        };
        /**
         * @des 直播活动 详情
         */
        this.content_live_details = {
            url: '/api/gateway/pcsd-bp-customer-bff-content/v1/bff/content/activity/info/detail/{activityId}',
            // awaitAuthenticated:false,
        };
        /**
         * @des 直播活动 详情 商品
         */
        this.content_live_product = {
            url: '/api/gateway/pcsd-bp-customer-bff-content/v1/bff/content/activity/info/findProductList',
            method: 'post',
            // awaitAuthenticated:false,
        };
        /**
         * @des 直播活动 详情 海报
         */
        this.content_live_posters = {
            url: '/api/gateway/pcsd-bp-customer-bff-content/v1/bff/content/activity/pic/listPicByActivityId',
            // awaitAuthenticated:false,
        };
        /**
         * @des 直播活动  推广记录器
         */
        this.content_live_record = {
            url: '/api/gateway/pcsd-bp-customer-bff-content/v1/promotion/record',
            method: 'post',
        };
        /**
         * @des 用户反馈提交
         */
        this.content_feekback_save = {
            url: '/api/gateway/pcsd-bp-customer-bff-content/v1/user/feedback/save',
            loading: true,
        };
        /**
         * @des 用户反馈类型
         */
        this.content_feekback_type = {
            url: '/api/gateway/pcsd-bp-customer-bff-content/v1/user/feedback/dropdown/feekbackType',
            awaitAuthenticated: false,
        };
    }
}
